import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CopyMenuBtn.module.scss';

const CopyMenuBtn: React.FC = () => {
	const { changeTypeOfModalWindow, IDSelectedRestaurant } = useContext<IDishesContext>(DishesContext);

	return (
		<div className={style.container}>
			<Button
				onClick={() => changeTypeOfModalWindow('copyMenuModal')}
				disabled={!IDSelectedRestaurant}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#copy`} />
					</svg>
				}>
				<Text translationNameSpace="listing" translationKey="copyMenuButton" asFragment={true} />
			</Button>
		</div>
	);
};

export default CopyMenuBtn;
